import { gsap } from "../shared/globals.js";

export function createMarqueeTextFeature() {
    let desktopTextStarted = false;
    let desktopTextTween = null;
    let desktopTextTweenSecondary = null;
    let mobileTextStarted = false;
    let mobileTextTween1 = null;
    let mobileTextTween2 = null;

    function startTextAnimation() {
        if (desktopTextStarted) return;
        desktopTextStarted = true;

        desktopTextTween = gsap.fromTo(
            "#myMovingText",
            { attr: { startOffset: "13%" } },
            {
                attr: { startOffset: "-111%" },
                duration: 30,
                ease: "none",
                repeat: -1,
            }
        );

        desktopTextTweenSecondary = gsap.fromTo(
            "#myMovingText2",
            { attr: { startOffset: "-125%" } },
            {
                attr: { startOffset: "-1%" },
                duration: 30,
                ease: "none",
                repeat: -1,
            }
        );
    }

    function stopTextAnimation() {
        if (desktopTextTween) {
            desktopTextTween.kill();
            desktopTextTween = null;
        }

        if (desktopTextTweenSecondary) {
            desktopTextTweenSecondary.kill();
            desktopTextTweenSecondary = null;
        }

        desktopTextStarted = false;
    }

    function startMobileTextAnimation() {
        if (mobileTextStarted) return;
        mobileTextStarted = true;

        mobileTextTween1 = gsap.fromTo(
            "#myMovingTextMobile",
            { attr: { startOffset: "0%" } },
            {
                attr: { startOffset: "-100%" },
                duration: 20,
                ease: "none",
                repeat: -1,
            }
        );

        mobileTextTween2 = gsap.fromTo(
            "#myMovingTextMobile2",
            { attr: { startOffset: "-100%" } },
            {
                attr: { startOffset: "0%" },
                duration: 20,
                ease: "none",
                repeat: -1,
            }
        );
    }

    function stopMobileTextAnimation() {
        if (mobileTextTween1) {
            mobileTextTween1.kill();
            mobileTextTween1 = null;
        }

        if (mobileTextTween2) {
            mobileTextTween2.kill();
            mobileTextTween2 = null;
        }

        mobileTextStarted = false;
    }

    function destroy() {
        stopTextAnimation();
        stopMobileTextAnimation();
    }

    return {
        startTextAnimation,
        stopTextAnimation,
        startMobileTextAnimation,
        stopMobileTextAnimation,
        destroy,
    };
}
